'use client';

import { type FC } from 'react';
import { Credits } from '../../Credits';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';

export const WinRangeCard: FC<{ ticket: number; className?: string }> = ({ ticket, className }) => {
  const { t } = useLocalTranslation(translations);
  return (
    <div className={className ?? 'mt-4 flex flex-col items-center rounded-2xl bg-bg-secondary p-4 text-center'}>
      <div className="text-xs font-semibold uppercase tracking-wide text-label-secondary">
        {t('winRangeTitle')}
      </div>
      <div className="mt-1.5 flex items-center justify-center gap-2 text-xl font-black text-side-t">
        <Credits amount={Math.round(ticket * 1.5)} iconSize={18} />
        <span className="text-label-secondary">—</span>
        <Credits amount={ticket * 5} iconSize={18} />
      </div>
    </div>
  );
};

export default WinRangeCard;
